import { render, staticRenderFns } from "./print-sums.vue?vue&type=template&id=cdc46d56&"
import script from "./print-sums.vue?vue&type=script&lang=ts&"
export * from "./print-sums.vue?vue&type=script&lang=ts&"
import style0 from "./print-sums.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdc46d56')) {
      api.createRecord('cdc46d56', component.options)
    } else {
      api.reload('cdc46d56', component.options)
    }
    module.hot.accept("./print-sums.vue?vue&type=template&id=cdc46d56&", function () {
      api.rerender('cdc46d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/projects/views/print-sums.vue"
export default component.exports